/* lua.js generated code 0.3.0 */

PaymentRecordManager = xClass("PaymentRecordManager")
var EXPIRE_TIME = 24 * 3600
var LOG_NUM_PER_REQ = 30
var _instance = null
PaymentRecordManager.getInstance = function () {
    var self = this
    if (!_instance) {
        _instance = PaymentRecordManager.new()
    }
    return _instance
}
PaymentRecordManager.prototype.ctor = function () {
    var self = this
    self.lastUpdateTime = 0
    self.recordLogs = table()
    self.isLogDirty = false
    self.readPaymentRecord()
}
PaymentRecordManager.prototype.setLogDirty = function () {
    var self = this
    self.isLogDirty = true
    self.flushLogsCache()
}
PaymentRecordManager.prototype.flushLogsCache = function () {
    var self = this
    var t = table(
        [1, "updateTime", self.lastUpdateTime],
        [1, "logs", self.recordLogs],
        [1, "isDirty", self.isLogDirty]
    )
    Localhost.getInstance().savePayRecordInfo(t)
}
PaymentRecordManager.prototype.readPaymentRecord = function () {
    var self = this
    var recordInfo = Localhost.getInstance().getPayRecordInfo() || table()
    self.lastUpdateTime = recordInfo.updateTime || 0
    self.recordLogs = recordInfo.logs || table()
    self.isLogDirty = recordInfo.isDirty || true
}
PaymentRecordManager.prototype.updateFromServer = function (refresh, onSuccess, onFail, onCancel) {
    var self = this
    var startNum = $or(refresh && 0, $len(self.recordLogs))
    var endNum = startNum + LOG_NUM_PER_REQ
    function onFinish(data) {
        if (refresh) {
            self.lastUpdateTime = Localhost.timeInSec()
            self.recordLogs = table()
            self.isLogDirty = false
        }
        var logs = data.data.logs || table()
        for (var k = 1, v = logs[1]; v; k++, v = logs[k]) {
            table.insert(self.recordLogs, v)
        }
        self.flushLogsCache()
        if (onSuccess) {
            onSuccess(logs)
        }
    }
    function onError(error) {
        if (onFail) {
            onFail(error)
        }
    }
    function onCancelled() {
        if (onCancel) {
            onCancel()
        }
    }
    var http = GetCashLogsHttp.new(true)
    http.addEventListener(Events.kComplete, onFinish)
    http.addEventListener(Events.kError, onError)
    http.addEventListener(Events.kCancel, onCancelled)
    http.load(startNum, endNum)
}
PaymentRecordManager.prototype.checkCacheExpired = function () {
    var self = this
    var time = Localhost.timeInSec()
    return time - self.lastUpdateTime > EXPIRE_TIME || self.isLogDirty
}
PaymentRecordManager.prototype.getPaymentRecord = function (onSuccess, onFail, onCancel) {
    var self = this
    if (self.checkCacheExpired()) {
        self.updateFromServer(true, onSuccess, onFail, onCancel)
    } else if (onSuccess) {
        onSuccess(self.recordLogs)
    }
}
PaymentRecordManager.prototype.clearRecords = function (onSuccess, onFail, onCancel) {
    var self = this
    function onFinish() {
        self.recordLogs = table()
        self.flushLogsCache()
        if (onSuccess) {
            onSuccess()
        }
    }
    function onError(err) {
        if (onFail) {
            onFail(err)
        }
    }
    var http = DeleteCashLogsHttp.new(true)
    http.addEventListener(Events.kComplete, onFinish)
    http.addEventListener(Events.kError, onError)
    http.addEventListener(Events.kCancel, onCancel)
    http.load()
}
module.exports = PaymentRecordManager
